import { PREFIX_COVERHOLDER } from "@/api/Model/ProductOwnerModel";
import AbstractLIORiskCode from "../LIORiskCode";

class LIORiskCode extends AbstractLIORiskCode {
  static getResourceEndpoint() {
    return PREFIX_COVERHOLDER + '/product-lio-risk-codes-ipr';
  }
}

export default LIORiskCode;
